(function() {
    var form = document.querySelector('[gr-form-change]');

    if (form) {
        var select = form.querySelectorAll('select');

        for (var indexSelect = 0, maxElementSelect = select.length; indexSelect < maxElementSelect; indexSelect++) {
            select[indexSelect].addEventListener('change', function() {
                form.submit();
            });
        }
    }
})();
